import React from 'react'
import MobileHeader from "../MobileComponents/MobileHeader";
import MobileBottomNav from "../MobileComponents/MobileBottomNav";
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CampaignIcon from '@mui/icons-material/Campaign';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useNavigate } from 'react-router-dom';

function MobileApartment() {
    const navigate = useNavigate()
    
  return (  
    <div className='mainwrapperView'>
    <MobileHeader/>
    <div className="wraperMobile">
        <div className='IconBoxWrapper'>
        <div className='IconBtn' onClick={()=>navigate('/Complains')}>
            <NewReleasesIcon sx={{fontSize:32, color: 'white'}} />
            <p>Complaints</p>
        </div>
        <div className='IconBtn' onClick={()=>navigate('/Polls')}>
            <EqualizerIcon sx={{fontSize:32, color: 'white'}} />
            <p>Polls</p>
        </div>
        <div className='IconBtn' onClick={()=>navigate('/SupportTicket')}>
            <QuestionAnswerIcon sx={{fontSize:32, color: 'white'}} />
            <p>Support Tickets</p>
        </div>
        <div className='IconBtn' onClick={()=>navigate('/UpcomingEvents')}>
            <CalendarMonthIcon sx={{fontSize:32, color: 'white'}} />
            <p>Upcoming Events</p>
        </div>
        <div className='IconBtn' onClick={()=>navigate('/NoticeBoard')}>
            <CampaignIcon sx={{fontSize:32, color: 'white'}} />
            <p>Notice Board</p>
        </div>
        <div className='IconBtn' onClick={()=>navigate('/Invoice')}>
            <ReceiptLongIcon sx={{fontSize:32, color: 'white'}} />
            <p>Maintenance Invoices</p>
        </div>
        </div>
    </div>
    <MobileBottomNav/>
</div>
  )
}

export default MobileApartment